/* eslint-disable no-script-url */
import { formatHashValue } from '@/utils';

import Button from '@/components/Button';
import ConnectWalletButton from '@/components/ConnectWalletButton';
import { TYPE } from '@/theme';
import { useAccountModal } from '@rainbow-me/rainbowkit';
import makeBlockie from 'ethereum-blockies-base64';
import styled from 'styled-components';

const StyledConnectWalletButton = styled(ConnectWalletButton)`
    border-radius: 12px !important;
    padding: 10px 20px !important;
    height: 37px !important;
    min-width: unset !important;
    font-weight: 400 !important;
`;

const StyledConnectedWalletButton = styled(Button)`
    border-radius: 12px !important;
    background: #f5f7ff !important;
    padding: 10px 20px !important;
    min-width: unset !important;
    font-weight: 400 !important;
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid #ebeffe;
    border-radius: 12px;
    height: 40px !important;

    img {
        width: 24px !important;
        height: 24px;
        border-radius: 12px;
    }
`;

interface Props {
    connected: boolean;
    walletAddress: string;
    className?: string;
}

export default function ConnectButton({ connected, walletAddress }: Props) {
    // const [isOpenAccountDetail, setIsOpenAccountDetail] = useState(false);

    const { openAccountModal } = useAccountModal();

    return (
        <>
            {!connected || !walletAddress ? (
                <StyledConnectWalletButton />
            ) : (
                <StyledConnectedWalletButton onClick={openAccountModal}>
                    <img src={makeBlockie(walletAddress)} alt="" />
                    <TYPE.main
                        color={'#000'}
                        fontSize={14}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {formatHashValue(walletAddress)}
                    </TYPE.main>
                </StyledConnectedWalletButton>
            )}
            {/* <AccountDetail
                isOpen={isOpenAccountDetail}
                onClose={() => setIsOpenAccountDetail(false)}
            /> */}
        </>
    );
}
